import { utcNow } from "./current";
import { CreateResult, DateUtilsConvertResult, DateUtilsNowResult, Manipulate, SDKDateObject } from "./types";

export function applyManipulations(date: SDKDateObject, manipulate: Manipulate[]): SDKDateObject {
  let processedDate = date;

  for (let index = 0; index < manipulate.length; index += 1) {
    const element = manipulate[index];
    if (element.method && element.args?.length) {
      const { method, args } = element;
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      processedDate = processedDate[method](...args);
    }
  }

  return processedDate;
}

export function createResult<ResultType extends DateUtilsConvertResult | DateUtilsNowResult>({
  object,
  fallback = "",
  toFormat,
}: CreateResult = {}): ResultType {
  const result: DateUtilsConvertResult = { object, string: fallback, success: false };
  if (result.object) {
    result.string = result.object.format(toFormat);
    result.success = true;
  }
  return result as ResultType;
}

export function isBeforeToday(utcDate: SDKDateObject): boolean {
  const { object: nowObject } = utcNow();
  try {
    return utcDate.isBefore(nowObject, "d") || false;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log("sdk -> functionisBeforeToday -> error", error);
    return false;
  }
}
